export const getSignatoryNameByFormat = (props) => {
    const { format, name, firstName, lastName } = props;
    if (format === 'firstNameLastName' && firstName && lastName) {
        return `${firstName} ${lastName}`;
    }
    return name;
};
